export const getPresentationParamsForOrigin = (): {
  competitionName: string;
  competitionId: string;
  appDomain: string;
  ledwallSponsor?: {
    "2x1920x144"?: {
      leftScreenFileURL?: string;
      rightScreenFileURL?: string;
    };
  };
  leaderboardPages: {
    key: string;
    title: string;
    groups: string[];
  }[];
  isDev: boolean;
  logo: {
    light: string;
    dark: string;
  };
  colors: {
    brand: [
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      ...string[],
    ];
  };
  links: {
    website?: string;
    magazine?: string;
    instagram?: string;
    tiktok?: string;
    youtube?: string;
    imprint: string;
    privacy: string;
    feedback?: string;
  };
  streamURL: (autostart: boolean) => string;
  ads?: {
    presentation?: {
      logoUrl: string;
      linkUrl: string;
      name: string;
    };
    banner?: {
      imageUrl: string;
      linkUrl: string;
    }[];
  };
  apps?: {
    android?: string;
    ios?: string;
  };
} => {
  const origin = window.location.origin;
  switch (origin) {
    case "https://app.freewaycup.de":
    case "http://192.168.1.250":
      return {
        competitionName: "FreewayCup",
        competitionId: "8065fb8f-b0a9-4c65-ae6c-3ba6a32d180e",
        appDomain: "app.freewaycup.de",
        leaderboardPages: [
          {
            key: "vorrunde",
            title: "Vorrundentabelle",
            groups: ["cef7f28a-1d50-430f-ae20-4b06ba4d1997"],
          },
        ],
        isDev: false,
        logo: {
          dark: "/img/fwc-logo/FWC Breit mit Logos blau.svg",
          light: "/img/fwc-logo/FWC Breit mit Logos weiß.svg",
        },
        colors: {
          brand: [
            "#eef3fc",
            "#dae4f2",
            "#b1c6e7",
            "#85a7dd",
            "#618cd5",
            "#4b7bd0",
            "#3f73cf",
            "#3262b7",
            "#285aa1",
            "#194383",
          ],
        },
        links: {
          website: "https://www.freewaycup.de",
          magazine:
            "https://freewaycup.de/wp-content/uploads/2026/01/FreewayCup-2026_Magazin.pdf",
          instagram: "https://www.instagram.com/freewaycup_official/",
          youtube: "https://www.youtube.com/@FreewayCup",
          tiktok: "https://www.tiktok.com/@officialfreewaycup",
          imprint: "https://www.freewaycup.de/impressum",
          privacy: "https://www.freewaycup.de/datenschutzerklaerung/",
          feedback: "https://freewaycup.de/app-feedback/",
        },
        apps: {
          android:
            "https://play.google.com/store/apps/details?id=de.freewaycup.app.twa",
        },
        streamURL: (autostart: boolean) =>
          `https://start.video-stream-hosting.de/player.html?p=VNBgwgwgiQn&playsinline=1&timelinecolor=285aa1&bgimage=https://app.freewaycup.de/img/screenshot-stream.jpg&autostart=${autostart ? "1&mute=1" : "0"}`,
      };
    case "http://localhost:5173":
    case "http://192.168.123.231":
    case "http://192.168.123.246:5173":
    case "http://100.77.78.87":
    case "https://app.girlssnowcup.de":
    default: {
      return {
        competitionName: "GirlsSnowCup",
        competitionId: "f091369b-87d5-4b5b-b287-42b2ad689d3e",
        appDomain: "app.girlssnowcup.de",
        leaderboardPages: [
          {
            key: "vorrunde",
            title: "Vorrunde",
            groups: [
              "8400fb1b-5a7e-461a-8e10-b8d036889458",
              "781fdffa-38df-4820-8e22-de48352e8b88",
              "1610d6ca-d334-43ca-95b4-a58a1fb47d4d",
              "65e652ea-d224-49ab-b754-a1fbc88cd248",
            ],
          },
          {
            key: "zwischenrunde",
            title: "Zwischenrunde",
            groups: [
              "338e9385-ef1f-4dec-a166-88c4938fbecb",
              "515ae762-7b92-434f-a665-417c0036a4d3",
              "c7513739-b98e-4ae5-ad65-584d4a6ac838",
              "681602ab-42a1-428b-82d4-7cc6c3fe548d",
            ],
          },
        ],
        isDev: false,
        logo: {
          dark: "/img/gsc-logo/gsc-breit-rot.svg",
          light: "/img/gsc-logo/gsc-breit-weiss.svg",
        },
        colors: {
          brand: [
            "#ffebeb",
            "#f9d1d1",
            "#f89f9e",
            "#f86a68",
            "#f9403b",
            "#f92b20",
            "#fa2113",
            "#df1708",
            "#c70f04",
            "#aa0000",
          ],
        },
        links: {
          website: "https://www.girlssnowcup.de",
          instagram: "https://www.instagram.com/gsc_official_site/",
          imprint: "https://www.girlssnowcup.de/impressum",
          privacy: "https://www.girlssnowcup.de/datenschutz",
          magazine:
            "https://app.girlssnowcup.de/app-assets/downloads/gsc-2026-magazin.pdf",
        },
        apps: {
          android:
            "https://play.google.com/store/apps/details?id=de.girlssnowcup.app.twa",
        },
        streamURL: () => {
          const hostname = window.location.hostname;
          return `https://player.twitch.tv/?channel=petkus_tv&parent=${hostname}`;
        },
        ads: {
          presentation: {
            logoUrl:
              "https://app.girlssnowcup.de/app-assets/sponsorlogo/lebensperspektiven-komplett.svg",
            linkUrl: "https://www.lebensperspektiven-ev.de/",
            name: "Lebensperspektiven e.V.",
          },
        },
        ledwallSponsor: {
          "2x1920x144": {
            leftScreenFileURL:
              "https://app.girlssnowcup.de/app-assets/ledwall/sponsors/1920x144/gsc-2026-left.mp4",
            rightScreenFileURL:
              "https://app.girlssnowcup.de/app-assets/ledwall/sponsors/1920x144/gsc-2026-right.mp4",
          },
        },
      };
    }
  }
};
